<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Master of Science</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Master of Science</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="bba ptb--100  horizontal--tab">
  <div class="container">
    <div class="row">
      <div class="col">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="department-tab" data-bs-toggle="tab" data-bs-target="#department"
              type="button" role="tab" aria-controls="department" aria-selected="true">About Department</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="eligibility-tab" data-bs-toggle="tab" data-bs-target="#eligibility"
              type="button" role="tab" aria-controls="eligibility" aria-selected="false">Eligibility Criteria</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="duration-tab" data-bs-toggle="tab" data-bs-target="#duration" type="button"
              role="tab" aria-controls="duration" aria-selected="false">Duration</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="opportunities-tab" data-bs-toggle="tab" data-bs-target="#opportunities"
              type="button" role="tab" aria-controls="opportunities" aria-selected="false">Opportunities which await
              you</button>
          </li>
        </ul>
        <div class="tab-content px-3 py-3" id="myTabContent">
          <div class="tab-pane fade show active" id="department" role="tabpanel" aria-labelledby="department-tab">
            <div>
              <p>Department is committed to academic excellence, research, and providing a dynamic learning environment
                for students pursuing a M.Sc. degree. M.Sc. Computer Science is post-graduation program which deals with
                subjects and topics related to computer application and services. Technological implementation of
                computer systems is the main agenda of the program. The program ranges widely from creating quality
                professionals and research fellows who are working in every sector of the world today. It aims to
                provide technology-oriented students with the knowledge and ability to develop creative solutions, and
                better understand the effects of future developments of computer systems and technology on people and
                society.</p>
            </div>
          </div>
          <div class="tab-pane fade" id="eligibility" role="tabpanel" aria-labelledby="eligibility-tab">
            <ul class="list-before">
              <li>Bachelor of CS with 50% marks and 45% marks for reserve category.</li>
              <li><strong>OR</strong></li>
              <li>BSc with 50% marks.</li>
              <li><strong>OR</strong></li>
              <li>A Bachelor of engineering in Computer Science/Information Technology/Electronics telecommunication
                with 50% marks </li>
              <li><strong>OR</strong></li>
              <li>BSc in IT or B.Sc in entire Computer Science with 50% marks </li>
              <li><strong>OR</strong></li>
              <li>B. Voc in software development/Information Technology with 50% marks </li>
              <li><strong>OR</strong></li>
              <li>BSc degree with Computer Science as principal subject or Computer Science as one of the subject as TY
                BSc level for student with general BSc with 50% marks.</li>
            </ul>
          </div>
          <div class="tab-pane fade" id="duration" role="tabpanel" aria-labelledby="duration-tab">
            <h4 class="yellow-color fw-bold">2 Year Postgraduate Program which included 4 Semester.</h4>

          </div>
          <div class="tab-pane fade" id="opportunities" role="tabpanel" aria-labelledby="opportunities-tab">
            <p>After completing an M.Com (Master of Commerce) degree, you have a variety of career opportunities
              available to you. M.Com graduates are sought after in various sectors due to their strong foundation in
              commerce, finance, and business. Work in public accounting firms, corporations, or government agencies to
              prepare and maintain financial records. Earn a professional certification such as a Certified Management
              Accountant (CMA) to specialize in cost management, budgeting, and financial analysis. Assist companies in
              raising capital, mergers and acquisitions, and financial advisory services. Oversee the planning and
              management of the supply chain, including procurement, logistics, and inventory management etc.</p>
          </div>
        </div>
        <div class="text-center">
          <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button">Apply Now</a>
        </div>
      </div>
    </div>
  </div>
</section>
